import React, { lazy } from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  const scrollToOffer = () => {
    document.getElementById('offer')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const painPoints = ['Dormís… pero te despertás agotada igual', 'Comés igual que antes, pero tu cintura cambió', 'Vivís cansada mentalmente, incluso cuando descansás.', 'Ansiedad, antojos, hinchazón que no ceden'];
  return <section className="bg-gradient-hero min-h-0 md:min-h-screen flex items-start pt-10 pb-12 md:pt-12 md:pb-16 relative overflow-hidden" data-id="element-149">
      <div className="absolute left-[8%] md:left-[20%] top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-gold/15 to-transparent" data-id="element-150" />
      <div className="absolute right-[8%] md:right-[20%] top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-gold/15 to-transparent" data-id="element-151" />

      <div className="max-w-[1400px] mx-auto px-5 md:px-8 w-full relative z-10" data-id="element-152">
        <div className="flex flex-col items-center text-center" data-id="element-153">
          <p className="uppercase tracking-[0.3em] text-[12px] text-[#C8A870] font-semibold mb-7" data-id="element-154">
            BALANCE HORMONAL 35+
          </p>

          <h1 className="font-display font-semibold leading-[1.08] tracking-tight max-w-4xl text-[#F0E8D8]" data-id="element-155">
            <span className="block text-[40px] md:text-6xl" data-id="element-156">
              Volvé a sentirte
            </span>
            <span className="block italic text-gradient-gold text-[38px] md:text-6xl my-1" data-id="element-157">
              liviana,
            </span>
            <span className="block text-[36px] md:text-5xl" data-id="element-158">
              descansá mejor y recuperá tu energía.
            </span>
          </h1>

          <p className="font-serif italic md:text-[22px] mt-6 text-[#F0E8D8]/90 text-[18px]" data-id="element-159">
            Lo que funcionaba antes puede no funcionar hoy.
          </p>
          <p className="mt-7 uppercase tracking-[0.18em] text-[12px] md:text-[13px] text-[#C8A870] font-semibold leading-[2]" data-id="element-160">
            ✦ Más energía&nbsp;&nbsp;&nbsp;✦ Menos hinchazón &nbsp;✦ Hábitos
            simples
          </p>

          <div className="relative mt-12 mb-10 w-full max-w-[19rem]" data-id="element-161">
            <div className="absolute inset-0 -z-10 flex items-center justify-center pointer-events-none" data-id="element-162">
              <div className="w-[75%] h-[75%] rounded-full bg-gold/10 blur-[80px]" data-id="element-163" />
            </div>

            <div className="relative text-center" data-id="element-164">
              <img src="https://cdn.shopify.com/s/files/1/0730/1614/8145/files/ebook_430x.webp?v=1780543244" alt="Protocolo H.E.R." width="340" height="456" loading="eager" fetchPriority="high" decoding="async" className="w-full max-w-[340px] mx-auto block rounded-[4px] shadow-[0_25px_60px_rgba(0,0,0,0.45)]" data-id="element-165" />
            </div>
          </div>

          <div className="max-w-md" data-id="element-166">
            <p className="font-display italic md:text-[26px] text-[23px] text-[#F0E8D8]" data-id="element-167">
              Tu equilibrio hormonal empieza acá.
            </p>
          </div>

          <img src="https://cdn.shopify.com/s/files/1/0730/1614/8145/files/ChatGPT_Image_9_jun_2026_02_48_17_p.m_430x.jpg?v=1781031076" alt="Mujer reflexionando" loading="lazy" decoding="async" className="w-full max-w-[430px] mx-auto rounded-xl my-8" data-id="element-168" />
          <div className="mt-8 text-center max-w-md mx-auto" data-id="element-169">
            <h3 className="font-display text-[32px] leading-tight text-foreground" data-id="element-170">
              ¿Te reconocés en alguna de estas situaciones?
            </h3>

            <ul className="mt-8 space-y-4 text-left" data-id="element-171">
              <li className="font-body text-[18px] text-foreground/80" data-id="element-172">
                ✓ Dormís pero no descansás.
              </li>

              <li className="font-body text-[18px] text-foreground/80" data-id="element-173">
                ✓ Tu cintura cambió aunque comés parecido.
              </li>

              <li className="font-body text-[18px] text-foreground/80" data-id="element-174">
                ✓ Hay días donde no te sentís vos.
              </li>

              <li className="font-body text-[18px] text-foreground/80" data-id="element-175">
                ✓ Ansiedad, antojos e hinchazón.
              </li>
            </ul>

            <div className="mt-10" data-id="element-176">
              <p className="font-display text-[34px] leading-tight text-foreground" data-id="element-177">
                No necesitás más esfuerzo.
              </p>

              <p className="font-display italic text-[#C8A870] text-[30px] leading-tight mt-2" data-id="element-178">
                Necesitás un sistema que te guíe en esta etapa.
              </p>
              <div className="mt-8 mb-10 max-w-md mx-auto text-center" data-id="element-179"></div>
            </div>
          </div>

          <section className="w-full max-w-[500px] mx-auto mt-12 overflow-hidden" aria-label="Biblioteca H.E.R." data-id="element-180">
            <p className="text-center tracking-[0.22em] uppercase text-[#c9a96e] mb-3 text-[13px]" data-id="element-181">
              Biblioteca Digital H.E.R.
            </p>

            <h2 className="text-center font-serif m-0 text-[32px] leading-[1.08]" data-id="element-182">
              <em className="text-[#c9a96e] italic" data-id="element-183">
                Todo lo que incluye H.E.R.
              </em>
            </h2>

            <p className="text-center text-[#f5f0e8]/55 mt-4 text-[13px] tracking-[0.06em]" data-id="element-184">
              Deslizá para ver todo lo incluido →
            </p>

            <div className="relative w-full overflow-hidden mt-5" data-id="element-185">
              <div className="flex gap-4 overflow-x-auto snap-x snap-mandatory px-[26px] pb-2 scrollbar-hide" data-id="element-186">
                {[{
                module: 'tracker',
                title: 'Tracker Premium',
                benefit: '✓ Visualizá tu progreso día a día',
                img: 'https://cdn.shopify.com/s/files/1/0730/1614/8145/files/v5gVLGm07qY3WP7hCr5Mp_430x.jpg?v=1780543245',
                pos: 'object-[center_18%]',
                alt: 'Tracker Premium H.E.R.'
              }, {
                module: 'noche',
                title: 'Noche en Calma',
                benefit: '✓ Dormí mejor sin complicarte',
                img: 'https://cdn.shopify.com/s/files/1/0730/1614/8145/files/qushb3WzLl3BYpA9n1eL_430x.jpg?v=1780543244',
                pos: 'object-[center_42%]',
                alt: 'Noche en Calma'
              }, {
                module: 'movement',
                title: 'H.E.R. Movement',
                benefit: '✓ Rutinas cortas que sí podés sostener',
                img: 'https://cdn.shopify.com/s/files/1/0730/1614/8145/files/S8SNVUZHdzf8t092yIlAK_430x.jpg?v=1780543245',
                pos: 'object-[center_34%]',
                alt: 'H.E.R. Movement'
              }, {
                module: 'organizacion',
                title: 'Organización Inteligente',
                benefit: '✓ Compras y planificación sin estrés',
                img: 'https://cdn.shopify.com/s/files/1/0730/1614/8145/files/1I1NNttJTHz_ql3yYujuX_430x.jpg?v=1780543245',
                pos: 'object-[center_18%]',
                alt: 'Organización Inteligente'
              }, {
                module: 'recetario',
                title: 'Recetario H.E.R.',
                benefit: '✓ Comidas simples para 21 días',
                img: 'https://cdn.shopify.com/s/files/1/0730/1614/8145/files/sOWIBzOpm0inWncyzKYoM_430x.jpg?v=1780543245',
                pos: 'object-[center_30%]',
                alt: 'Recetario H.E.R.'
              }].map(item => <article key={item.module} className="shrink-0 basis-[72%] snap-center border border-[#c9a96e]/20 rounded-[18px] bg-[#141210] overflow-hidden" data-id="element-187">
                    <div className="h-[220px] overflow-hidden bg-[#090807]" data-id="element-188">
                      <img src={item.img} alt={item.alt} loading="lazy" decoding="async" className={`w-full h-full object-cover ${item.pos}`} data-id="element-189" />
                    </div>

                    <div className="px-[18px] py-4" data-id="element-190">
                      <h3 className="font-serif text-[22px] leading-[1.08] text-[#f5f0e8] text-center" data-id="element-191">
                        {item.title}
                      </h3>

                      <p className="mt-3 text-center text-[15px] leading-snug text-[#c9a96e] font-medium" data-id="element-192">
                        {item.benefit}
                      </p>
                    </div>
                  </article>)}
              </div>
            </div>

            <div className="text-center max-w-[350px] mx-auto mt-6" data-id="element-193">
              <p className="text-[#f5f0e8]/50 text-[13px] line-through" data-id="element-194">
                Valor individual de los recursos: $44.000
              </p>

              <p className="mt-1 text-[#f5f0e8]/75 font-[500] text-[15px]" data-id="element-195">
                <strong className="text-[#e8d5b0] font-medium" data-id="element-196">
                  ✦ Acceso completo a H.E.R. hoy por $12.000 ✦
                </strong>
              </p>
            </div>
          </section>

          <div className="pt-10 flex flex-col items-center w-full max-w-md space-y-4" data-id="element-197">
            <CTAButton section="hero" onClick={scrollToOffer} data-id="element-198">
              Acceder al Protocolo H.E.R.
            </CTAButton>

            <p className="uppercase tracking-[0.14em] md:text-[12px] font-body text-center text-[11px] text-[#C8A870]" data-id="element-199">
              ✦Acceso inmediato&nbsp;✦Garantía 30 días&nbsp;✦Pago seguro&nbsp;✦3
              CUOTAS DE $4.000 mercado pago
            </p>
          </div>

          <div className="mt-14 w-full max-w-xl" data-id="element-200">
            <div className="card-premium p-6 backdrop-blur-sm text-left" data-id="element-201">
              <p className="text-[11px] tracking-[0.2em] uppercase text-[#C8A870] font-semibold mb-3" data-id="element-202">
                Una alumna dijo:
              </p>

              <p className="italic text-[#F5EFE4] text-[17px]" data-id="element-203">
                “Por primera vez sentí que estaba siguiendo un plan pensado para
                esta etapa de mi vida.”
              </p>

              <p className="mt-4 text-[15px] text-[#E8DCC8]" data-id="element-204">
                — Laura, 52 · Argentina
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}